import { memo, ReactNode } from "react";
import { useBox } from "./hooks";

interface BoxProps {
  children?: ReactNode;
  title?: ReactNode;
  required?: boolean;
  bodyClass?: string | ReactNode;
  boxClass?: string | ReactNode;
  overflown?: boolean;
}

export const Box = memo(
  ({
    children,
    title = "",
    required,
    bodyClass = "",
    boxClass = "",
    overflown = true,
  }: BoxProps) => {
    let boxBodyClass = "body " + bodyClass;
    boxBodyClass += overflown ? " overflown" : "";
    const { toggleClose } = useBox();

    return (
      <div className={`box ${boxClass}`}>
        <h4 className="head" onClick={toggleClose}>
          {title}
          {required && <sup>*</sup>}
        </h4>
        <div className={boxBodyClass}>{children}</div>
      </div>
    );
  }
);
